var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticClass:"common_v-btn",style:(_vm.cssProps),on:{"click":_vm.clicked}},[_vm._v(_vm._s(_vm.btnName)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }